import ShowTextbook from "./ShowTextbook";
import BookNavbar from "../../components/Navbar";

export default function ShowTextbookPage() {
    return (
        <div>
            <BookNavbar />
            <ShowTextbook />
        </div>
    );
}